import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PurchaseOrderLineStockIssue } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderStockIssueService extends TmsWebBaseEditService<
  PurchaseOrderLineStockIssue,
  PurchaseOrderLineStockIssue
> {
  constructor() {
    super('PurchaseOrderStockIssue', $localize`Purchase Order Stock Issue`);
  }

  issue(purchaseOrderLineId: string, stockItemId?: string): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/Issue`, {
      purchaseOrderLineId,
      stockItemId,
    });
  }

  unIssue(purchaseOrderLineId: string) {
    return this.httpService.post<any>(`${this.apiUrl}/UnIssue`, { purchaseOrderLineId });
  }
}
